import styled from 'styled-components';
import * as Semantic from 'semantic-ui-react';

export const PhoneticsEditor = styled.textarea`
  font-family: monospace;
  resize: vertical;
  border: 1px solid rgba(128, 128, 128, 0.15);
  border-radius: 3px;

  width: 100%;
  height: 7.7rem;

  font-size: 3rem;
  padding: 2rem;
  text-align: center;
  line-height: normal;
`;

export const TestableTextEditor = styled.input`
  font-family: monospace;
  resize: vertical;
  border: 1px solid rgba(128, 128, 128, 0.15);
  border-radius: 3px;

  width: 100%;

  font-size: 1.7rem;
  padding: 1rem;
  line-height: normal;
`;

export const StemEditor = styled.input`
  font-family: monospace;
  border: 1px solid rgba(128, 128, 128, 0.15);
  border-radius: 3px;

  width: 100%;

  font-size: 1.2rem;
  padding: 0.7rem;
  line-height: normal;
`;

export const DescriptionEditor = styled.input`
  font-family: Lato, 'Helvetica Neue', Arial, Helvetica, sans-serif;
  border: 1px solid rgba(128, 128, 128, 0.15);
  border-radius: 3px;

  width: 100%;

  font-size: 1.1rem;
  padding: 0.7rem;
  line-height: normal;
`;

export const FreeTextPhoneticEditor = styled.textarea`
  font-family: Lato, 'Helvetica Neue', Arial, Helvetica, sans-serif;
  border: 1px solid rgba(128, 128, 128, 0.15);
  border-radius: 3px;

  width: 100%;
  height: 200px;

  font-size: 1.1rem;
  padding: 0.7rem;
  line-height: normal;
`;

export const SayAsToggle = styled.div`
  display: inline-block;

  order: 2;
  margin-left: auto;
  margin-bottom: auto;
  font-size: 1.1rem;
`;

export const LexemeRow = styled.div`
  display: flex;
  align-items: baseline;
  gap: 0.6rem;
  flex-wrap: wrap;
`;

export const LexemeGrapheme = styled.span`
  font-weight: 600;
  font-size: 1rem;
`;

export const LexemeContent = styled.span`
  font-family: monospace;
  color: #555;
`;

export const LexemeStem = styled.span`
  color: #888;
  font-style: italic;
  font-size: 0.9rem;
`;

export const PhoneticLetter = styled.span`
  // inline-block lets the letter list wrap between letters instead of splitting a symbol like 'yː'
  display: inline-block;
  background-color: #d4d4d4;
  word-wrap: break-word;
  border-radius: 3px;
  padding: 0.1em 0.2em;
  font-size: 1rem;
  font-family: monospace;
  margin-left: 4px;
`;

export const PhoneticInfo = styled.div`
  & p:first-child {
    margin: 0;
  }
  opacity: 0.3;

  &:hover {
    opacity: 1;
  }
  margin-bottom: 1em;
  color: #595959;
`;

export const CopyIcon = styled(Semantic.Icon)`
  position: absolute;
  top: 1rem;
  right: 1rem;
`;

export const TestModalTitle = styled.h2`
  color: #595959;
`;

export const StickyTableFooter = styled(Semantic.Table.Footer)`
  position: sticky;
  bottom: 0;
  border-bottom: unset; // Prevents 1px bottom gap
  background: white;
`;

export const PhoneticRow = styled(Semantic.Table.Row)<{ selected: boolean }>`
  background-color: ${(props) => (props.selected ? 'darkgrey' : 'inherit')};

  &:hover {
    background-color: ${(props) => !props.selected && 'rgba(0, 0, 0, 0.05)'};
    cursor: pointer;
  }
  user-select: none;
`;

export const PhoneticActionContainer = styled.div`
  display: flex;
  flex-direction: row;
`;

export const PhoneticEntryActionIcon = styled(Semantic.Icon)`
  transition: opacity 0.3s ease-in-out;
  opacity: 0.5 !important;
  &:hover {
    opacity: 1 !important;
  }
`;

export const TableWrapper = styled.div`
  overflow: auto;
  max-height: 85vh;
`;

export const LanguageContainer = styled.div`
  border-top: 1px solid rgba(34, 36, 38, 0.15);
  margin-top: 15px;
  padding-top: 15px;
`;
